import React from 'react';
import { Box, Typography, Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { StripedDataGrid } from '../../../styledComponents/datagrid';
import { renderCellExpand } from '../../../components/library/DataGrid/renderCellExpand';
import { InventoryTransferItem } from '../../../services/inventory/types';

interface InventoryTransferItemDetailsProps {
  items: InventoryTransferItem[];
}

const columns: GridColDef[] = [
  {
    headerName: 'SKU',
    field: 'sku',
    renderCell: renderCellExpand,
    flex: 2,
  },
  {
    headerName: 'Quantity Transferred',
    field: 'quantityTransferred',
    flex: 2,
    renderCell: params => (
      <Chip label={params.value} color="primary" size="small" variant="outlined" />
    ),
  },
  {
    headerName: 'From Bin',
    field: 'fromWarehouseBin',
    flex: 2,
    renderCell: params => (
      <Typography variant="body2">
        {params.value?.code || `BinId: ${params.row.fromWarehouseBinId}`}
      </Typography>
    ),
  },
  {
    headerName: 'To Bin',
    field: 'toWarehouseBin',
    flex: 2,
    renderCell: params => (
      <Typography variant="body2">
        {params.value?.code || `BinId: ${params.row.toWarehouseBinId}`}
      </Typography>
    ),
  },
  {
    headerName: 'From Inspection Status',
    field: 'fromInspectionStatus',
    flex: 2,
    renderCell: params => <Typography variant="body2">{params.value?.name || 'N/A'}</Typography>,
  },
  {
    headerName: 'To Inspection Status',
    field: 'toInspectionStatus',
    flex: 2,
    renderCell: params => <Typography variant="body2">{params.value?.name || 'N/A'}</Typography>,
  },
];

const InventoryTransferItemDetails: React.FC<InventoryTransferItemDetailsProps> = ({ items }) => {
  if (!items || items.length === 0) {
    return (
      <Box sx={{ p: 2 }}>
        <Typography variant="body2" color="text.secondary">
          No items found for this transfer.
        </Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h6" gutterBottom>
        Transfer Items ({items.length})
      </Typography>
      <StripedDataGrid rows={items} columns={columns} />
    </Box>
  );
};

export default InventoryTransferItemDetails;
